<template lang="pug">
  div.flex.min-h-screen.justify-center.relative
    #dashboard.w-full.max-w-5xl.mt-32.flex.flex-col.items-stretch
      div(v-if="showOnboarding")
        Onboarding
      
      div(v-else)
        .flex.align-center.font-medium
          p.flex.align-center.text-gray-6 Dashboard

        .flex.justify-between.items-center
          h2.font-semibold.text-2xl.text-gray-9.mt-2 {{ company.name }}
          router-link.button.icon.main.small.overflow-hidden.pr-1.my-2(v-if="keyResults.length" to="/update")
            eva-icon.icon.text-indigo-3.bg-indigo-8.rounded-tr-lg.rounded-br-lg.p-1(name="plus") 
            span.mx-2 Add updates

        //.text-2xl.-mx-2
          .flex.items-baseline
            .tab(:class="{ active: currentTab == 'All' }") All
            .tab(v-for="team in teams" :class="{ active: currentTab == team }") {{team}}

        .border-b.w-full.my-4
        
        Purpose.mt-8.-ml-12(class="lg:ml-0")

        .border-b.w-full.my-6
        
        .flex.justify-between.items-center
          h3.text-sm.text-gray-6.font-medium Objectives this year
          button.small.shadow-none.-mr-2(@click="showObjModal = true")
            eva-icon.icon.text-indigo-4(name="plus") 
            span.mx-1.text-indigo-9 Add objective

        Objective.mt-2.mb-12.-ml-12(class="lg:ml-0" v-for="(objective, index) in liveObjectives" :key="objective.id" :index="index" :objective="objective")

        .border-b.w-full.my-6

        h3.text-sm.text-gray-6.font-medium.flex.items-center.cursor-pointer(@click="showArchives = !showArchives") Archived objectives
          eva-icon.icon.text-gray-5(:class="{ drop: showArchives }" name="chevron-right")
        Objective.mt-2.mb-12.-ml-12(class="lg:ml-0" v-if="showArchives" v-for="(objective, index) in archives" :key="objective.id" :index="index" :objective="objective")
      div.h-32
    
    Modal(v-if="showObjModal" @close="showObjModal = false")
      form.card.max-w-sm.w-full(class="sm:rounded-b-none sm:rounded-t-xl sm:p-8" @submit.prevent="createObj")
        label Define an objective for the year
        input.p-2(v-focus v-model="newObj")
        button.main.mt-4(type="submit") Create objective

  </template>

<script>
import Onboarding from "../components/Onboarding";
import Purpose from "../components/Purpose";
import Objective from "../components/Objective";
import Modal from "../templates/Modal";
import { auth } from "../firebase.config";

import { mapGetters } from "vuex";

export default {
  components: { Onboarding, Purpose, Objective, Modal },
  data() {
    return {
      showArchives: false,
      newObj: "",
      showObjModal: false,
    };
  },
  methods: {
    createObj() {
      this.loading = true;
      this.showObjModal = false;
      this.$store
        .dispatch("createDoc", {
          collection: "objectives",
          item: {
            title: this.newObj,
            companyId: this.profile.companyId,
            createdBy: auth.currentUser.uid,
          },
        })
        .then(() =>
          this.$store.dispatch("getObjectives", this.profile.companyId)
        )
        .then(() => {
          this.loading = false;
          return this.$store.dispatch("fireNotification", {
            title: "Created your objective",
            type: "success",
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    ...mapGetters([
      "profile",
      "company",
      "gettingObjectives",
      "isSigningIn",
      "gettingCompany",
      "objectives",
      "keyResults",
    ]),
    liveObjectives() {
      return this.objectives.filter((obj) => !obj.archived);
    },
    archives() {
      return this.objectives.filter((obj) => obj.archived);
    },
    showOnboarding() {
      var isSetup =
        this.company &&
        this.company.name &&
        this.company.purpose &&
        this.objectives.length &&
        this.company.members.length > 1;
      if (!this.profile.onboarded && !isSetup) return true;
      else return false;
    },
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
};
</script>

<style lang="sass" scoped></style>
